// generated by recipeyak.api.base.codegen
import { http } from "@/apiClient"

export function ingredientDelete(params: { ingredient_id: number }) {
  return http<unknown>({
    url: "/api/v1/ingredients/{ingredient_id}/",
    method: "delete",
    params,
    pathParamNames: ["ingredient_id"],
  })
}
